import http from '@/requests/http'

class Big {
  static all (params) {
    return http.post('configuration/consultation/big/index', params)
  }
  static async view (params) {
    return http.post('configuration/consultation/big/view', params)
  }
  static async update (data) {
    return http.post('configuration/consultation/big/update', data)
  }
  static async save (data) {
    return http.post('configuration/consultation/big/store', data)
  }
  static async delete (id) {
    return http.post(`configuration/consultation/big/delete/${id}`)
  }
  static async getSmalls (params) {
    return http.post('configuration/consultation/big/get-smalls', params)
  }
  // Todo: Replace getSmalls with getSmallOptions
  static async getSmallOptions (params) {
    return http.post('configuration/consultation/big/get-small-options', params)
  }
}

export default Big
